// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Icon from 'antd/lib/icon';
//
import LineItemInput from 'components/inputs/LineItemInput';
import uuidv1 from 'uuid/v1';

const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};
const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 20, offset: 4 },
  },
};

let lineItemConfig = {
  initialValue: { description: null, amount: 0 },
  validateTrigger: ['onBlur'],
  rules: [
    {
      required: true,
      whitespace: true,
      message: 'Please input a value or delete this field.',
    },
  ],
};

const RemoveButton = ({ keys, onClick }) => {
  if (keys.length > 1) {
    return (
      <Icon
        className="dynamic-delete-button"
        type="minus-circle-o"
        style={{ cursor: 'pointer' }}
        disabled={keys.length === 1}
        onClick={onClick}
      />
    );
  } else {
    return null;
  }
};

class LineItemsForm extends React.Component {
  remove = k => {
    const { keys, onChange } = this.props;
    // We need at least one passenger
    if (keys.length === 1) {
      return;
    }
    // can use data-binding to set
    onChange({
      keys: keys.filter(key => key !== k),
    });
  };

  add = () => {
    //uuid++;
    const { record, keys, onChange } = this.props;
    // can use data-binding to get
    let newKey = uuidv1();
    const nextKeys = keys.concat(newKey);

    onChange({
      keys: nextKeys,
      [`names-${newKey}`]: { amount: '0.00', description: '' },
    });
  };

  render() {
    return (
      <div>
        {this.props.keys.map &&
          this.props.keys.map((k, index) => {
            // grab the current value for amount/description from the invoice object. k == a unique id for each line item that we generate client-side with uuid
            let currentValue = this.props.record[`names-${k}`];

            return (
              <FormItem
                {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                label={index === 0 ? 'Line Items' : ''}
                required={false}
                key={k}
              >
                <Row type="flex" align="middle" justify="center">
                  <Col xs={23} sm={22}>
                    <LineItemInput
                      key={k}
                      value={{
                        description: currentValue && currentValue.description,
                        amount: currentValue && currentValue.amount,
                      }}
                      onChange={value =>
                        this.props.onChange({
                          [`names-${k}`]: value,
                        })
                      }
                      currencySymbol={this.props.currencySymbol}
                    />
                  </Col>
                  <Col xs={1} sm={2} style={{ textAlign: 'center' }}>
                    <RemoveButton k={k} keys={this.props.keys} onClick={() => this.remove(k)} />
                  </Col>
                </Row>
              </FormItem>
            );
          })}
        <FormItem {...formItemLayoutWithOutLabel}>
          <Button type="dashed" onClick={this.add}>
            <Icon type="plus" /> Add line item
          </Button>
        </FormItem>
      </div>
    );
  }
}

export default LineItemsForm;



// WEBPACK FOOTER //
// ./src/components/forms/LineItemsForm/index.js